import { Outlet } from 'react-router-dom';

import { useSessionReplayWindow } from '@/shared/analytics/useSessionReplayWindow';
import { InvoiceAssistantShell } from '../assistant/InvoiceAssistantShell';
import { InvoiceAssistantProvider } from '../assistant/useInvoiceAssistant';
import { SealActivationNotice } from '../components/SealActivationNotice';
import { InvoiceFlowProvider } from '../hooks/useInvoiceFlow';

/**
 * Un único provider por encima del home, de los tres pasos, de la pantalla de
 * sellos y de la página del QR.
 *
 * Contrato: el borrador tiene que sobrevivir la navegación del home al wizard.
 * Con un provider por rama, elegir receptor y navegar desmonta el estado antes
 * de que el autoguardado (debounce de 800ms) lo escriba, y el paso 1 rebota al
 * home por borrador sin receptor.
 */
export const InvoicingLayout = () => {
  useSessionReplayWindow('invoicing_v2', true);

  return (
    <InvoiceFlowProvider>
      <InvoiceAssistantProvider>
        <InvoiceAssistantShell>
          <Outlet />
        </InvoiceAssistantShell>
        <SealActivationNotice />
      </InvoiceAssistantProvider>
    </InvoiceFlowProvider>
  );
};
